import { z } from 'zod';

export const loginSchema = z.object({
  username: z.string().min(1, 'username_required').max(120, 'username_too_long'),
  password: z.string().min(1, 'password_required').max(255, 'password_too_long'),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
